
export const ContentOriginalImage = ({src, className}) => {
    return (
        <img
            src={src}
            className={className}
            alt="alphatub"
        />
    )
}